import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { AnalyticsService } from "@/services/analytics-service";

export const ClickIdSync = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <Don't need to sync on each pathname change>
  useEffect(() => {
    const newSearchParams = AnalyticsService.initializeClickId();
    const currentSearchParams = new URLSearchParams(location.search);

    const newParamsString = newSearchParams.toString();
    const currentParamsString = currentSearchParams.toString();

    if (newParamsString !== currentParamsString) {
      navigate(
        {
          pathname: location.pathname,
          search: newParamsString,
        },
        { replace: true },
      );
    }
  }, []);

  return null;
};
